import { AutoComplete, AutoCompleteProps, Button, Flex, Form, FormProps, Input, Radio, RadioChangeEvent, Select } from "antd";
import { SizeType } from "antd/es/config-provider/SizeContext";
import TextArea from "antd/es/input/TextArea";
import { SetStateAction, useEffect, useState } from "react";
import { FacilityInterface } from "../../model/IResearcher";
import { ProjectInfoInterface } from "../../model/IprojectInfo";
import LoadingOverlay from 'react-loading-overlay-ts';
import { useForm } from "antd/es/form/Form";
import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export function Draft() {
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const [fullname, setFullname] = useState(sessionStorage.getItem('fullname')&&'f' || 'test');
    const [facData,setFacData] = useState<FacilityInterface[]>([])
    const [value, setValue] = useState('');
    const [otherPosition, setOtherPosition] = useState('');
    const [userID,setUserID] = useState('')
    const [form] = Form.useForm();
    const [loading,setLoading]= useState(false);

    const navigate = useNavigate();
    
    const style: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        marginLeft: '40px'
      };

      const onChange = (e: RadioChangeEvent) => {
        setValue(e.target.value);
      };

      const OtheronChange = (e: { target: { value: SetStateAction<string>; }; }) => {
        setValue(e.target.value);
        if (e.target.value !== 'อื่นๆ') {
          setOtherPosition(''); // clear if not "อื่นๆ"
        }
      };
      const isDisabledStudent =
        sessionStorage.getItem('POS_ID') !== null &&
        sessionStorage.getItem('POS_ID') !== ''
      const isInside = 
        sessionStorage.getItem('status') == 'Insider'

      useEffect(() => {
        const FaciData = sessionStorage.getItem('POS_ID');
        const ID = sessionStorage.getItem('user');
        const name = sessionStorage.getItem('fullname')
        const Fac_name = sessionStorage.getItem('Fac_name')
        const FacID = sessionStorage.getItem('Fac_ID')
        const userEmail = sessionStorage.getItem('userEmail')
        
        console.log(isDisabledStudent)
        if (FaciData) {
            const TmpFacData = JSON.parse(FaciData)
            console.log(TmpFacData)
            setFacData(TmpFacData);
        }else if(Fac_name&&FacID) {
          setFacData([
            {
              Fac_ID:Number(FacID),
              Fac_NameTH:Fac_name,
              Fac_NameEN:'-',
              Pos_ID:0,
              Pos_NameTH:'',
            }])
        }
     
        if (ID) {
          setUserID(ID);
        }
        if(name){
          form.setFieldValue('headname',name)
        }
        if(isDisabledStudent&&Fac_name){
          form.setFieldValue('fac_name',Fac_name)
        }
        if(userEmail){
          form.setFieldValue('email',userEmail)
        }

        if(sessionStorage.getItem('status')=='Outsider')
          { 
              axios.get(`${process.env.REACT_APP_BASE}/getOutsiderdata/${sessionStorage.getItem('user')}`).then(response=>{
              if(response.status==200){
                console.log(response.data[0])
                  form.setFieldsValue({
                    ENheadname:response.data[0].ENfullname
                  })
              }
          })}


      }, []);

      const [options, setOptions] = React.useState<AutoCompleteProps['options']>([]);
      const handleSearch = (value: string) => {
        setOptions(() => {
        if (!value || value.includes('@')) {
            return [];
        }
        return ['gmail.com', 
                'yahoo.com', 
                'hotmail.com', 
                'outlook.com', 
            ].map((domain) => ({
            label: `${value}@${domain}`,
            value: `${value}@${domain}`,
        }));
        });
    };

      const SaveDraft: FormProps<ProjectInfoInterface>['onFinish'] = async (values) => {
        const FormData = form.getFieldsValue()
        setLoading(true)
        console.log(FormData)
        const data = {
          project_nameTH:FormData.project_nameTH,
          project_nameEN:FormData.project_name_en,
          HeadID:userID,
          headname:FormData.headname,
          headnameEn:FormData.ENheadname,
          position: value === 'อื่นๆ' ? otherPosition : value,
          InsiderStatus:sessionStorage.getItem('status'),
          fac_name:FormData.fac_name,
          phonenum:FormData.phone,
          email:FormData.email,
          IsInsider:isInside
        }
        console.log(data)
        axios.post(`${process.env.REACT_APP_BASE}/saveDraft`, data)
        .then(response => {
          if (response.status == 200) {
            setLoading(false)
            console.log(response.data)
            sessionStorage.setItem('Order_ID',response.data.OrderID)
            navigate('/VU_HREC/EhticalReq');
          }
        })
        .catch(error => {
          setLoading(false)
          console.error('🔥 SaveDraft ERROR:', error.response?.data || error.message);
        });
      }
    return (
        <>
         <LoadingOverlay active={loading} 
              spinner
              text='กำลังโหลดข้อมูล'>
            <h1>แบบร่างคำขอ</h1>
            <hr/>
            <Form
                wrapperCol={{ span: 20 }}
                layout="vertical"
                autoComplete="off"
                form={form}
                size={componentSize as SizeType}
                onFinish={SaveDraft}
                style={{
                padding:15
                }}>
                <Form.Item
                    name="project_nameTH"
                    className="font-semibold"
                    label={<span style={{ fontWeight: 'bold' }}>ชื่อโครงการวิจัย</span>}
                    style={{ maxWidth: 800 }}
                    rules={[
                        {
                        required: true,
                        message: 'ชื่อโครงการวิจัยของท่านไม่สามารถปล่อยว่างได้',
                        },
                    ]}
                    >
                    <TextArea 
                        className='font-normal'
                        style={{marginLeft: '40px'}}
                        placeholder="ชื่อโครงการภาษาไทย" autoSize />
                </Form.Item>
                <Form.Item style={{ maxWidth: 800 }} name='project_name_en'
                    rules={[{ required: true, 
                    message: 'ชื่อโครงการวิจัยของท่านไม่สามารถปล่อยว่างได้'},
                    {
                    pattern: /^[a-zA-Z0-9\s!@#$%^&*()_+={}:;"'<>,.?\/`~\-]*$/ ,
                    message: 'ชื่อโครงการของท่านที่กรอกในช่องนี้ ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข และสัญลักษณ์เท่านั้น'
                    }]}>
                    <TextArea style={{marginLeft: '40px'}}
                    placeholder="ชื่อโครงการภาษาอังกฤษ" autoSize />
                </Form.Item>
                <Form.Item name='headname' label={<span style={{ fontWeight: 'bold' }}>ชื่อผู้วิจัย</span>}>
                    <Input style={{marginLeft: '40px'}} 
                    disabled/>
                </Form.Item>
                <Form.Item name='ENheadname' >
                  {sessionStorage.getItem('status')=='Outsider'&&<Input style={{marginLeft: '40px'}} 
                    value=''
                    disabled/>||
                    <Input style={{marginLeft: '40px'}} 
                    value=''
                    />}
                    
                </Form.Item>
                <Form.Item name='position_name' rules={[{ required: true, message: 'กรุณาเลือกตำแหน่งของท่าน' }]}  label={<span style={{ fontWeight: 'bold' }}>ตำแหน่งหัวหน้าโครงการวิจัย</span>}>
                    <Radio.Group style={style} 
                    value={value}
                    onChange={onChange}
                    options={[
                        { value: 'อาจารย์', label: 'อาจารย์', disabled:!isDisabledStudent&&isInside },
                        { value: 'บุคลากร', label: 'บุคลากร', disabled:!isDisabledStudent&&isInside },
                        { value: 'นักศึกษาระดับปริญญาตรี', label: 'นักศึกษาระดับปริญญาตรี' , disabled:isDisabledStudent&&isInside },
                        { value: 'นักศึกษาระดับปริญญาโท', label: 'นักศึกษาระดับปริญญาโท', disabled:isDisabledStudent&&isInside },
                        { value: 'นักศึกษาระดับปริญญาเอก', label: 'นักศึกษาระดับปริญญาเอก', disabled:isDisabledStudent&&isInside},
                        {
                          value: 'อื่นๆ',
                          label: (
                            <>
                              อื่นๆ
                              {value === 'อื่นๆ' && (
                                <Input
                                  variant="filled"
                                  placeholder="กรุณาระบุ"
                                  style={{ width: 120, marginInlineStart: 12 }}
                                  value={otherPosition}
                                  onChange={(e) => setOtherPosition(e.target.value)}
                                />
                              )}
                            </>
                          ),
                        },
                      ]}>
                    </Radio.Group>
                </Form.Item>
                <Form.Item name='fac_name' rules={[{ required: true, message: 'กรุณาเลือกสังกัด' }]} label={<span style={{ fontWeight: 'bold' }}>สังกัดหัวหน้าโครงการวิจัย</span>}>
                    {isInside&&<Select 
                        style={{marginLeft: '40px'}}
                        options={
                          facData.map((item)=>( 
                            { value: item.Fac_NameTH, label:item.Fac_NameTH }))
                        }/>||
                        <Input style={{marginLeft: '40px'}}/>
                        }
                </Form.Item>
                <Form.Item name='phone'
                 rules={[{ required: true, message: 'เบอร์โทรศัพท์ติดต่อหัวหน้าโครงการวิจัยไม่สามารถปลอยว่างได้' }]} label={<span style={{ fontWeight: 'bold' }}>เบอร์โทรศัพท์ติดต่อหัวหน้าโครงการวิจัย</span>}>
                <Input style={{marginLeft: '40px'}}/>
                    </Form.Item>
                <Form.Item name='email' 
                 rules={[
                  { required: true, message: 'email ไม่สามารถปล่อยว่างได้' },
                  {
                  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: 'รูปแบบ email ไม่ถูกต้อง',
                  },
              ]}
                label={<span style={{ fontWeight: 'bold' }}>Email หัวหน้าโครงการวิจัย</span>}>
                    <AutoComplete
                      style={{marginLeft: '40px'}}
                        onSearch={handleSearch}
                        options={options}
                        />
                </Form.Item>
                <Flex justify='flex-end'>
                    <Button htmlType='submit' type='primary'>บันทึกฉบับร่าง</Button>
                </Flex>
            </Form></LoadingOverlay>
        </>
    );
}
